import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

interface Props {
  items: {
    title: string;
    link?: string;
  }[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AppBreadcrumbs',
  props: {
    items: null
  },
  setup(__props: any) {

const props = __props as {
  items: {
    title: string;
    link?: string;
  }[];
};



const links = computed(() => {
  return [
    {
      title: 'Canyon',
      link: '/',
    },
    ...props.items,
  ];
});

const isLastItem = (index: number) => index === links.value.length - 1;

return { __sfc: true,props, links, isLastItem }
}

})